import getCategory from "./shopcate"
import getProduct from "./product"
import getLogin from "./login"
import getShop from "./shop"
import getArticle from "./article"
import getOrder from "./order"
import getCoupon from "./coupon"
import getUser from "./user"
import getIm from "./im"

export default{
    getCategory,
    getProduct,
    getLogin,
    getShop,
    getArticle,
    getOrder,
    getCoupon,
    getUser,
    getIm
};


// WEBPACK FOOTER //
// ./src/assets/js/api/require/index.js